import { render, staticRenderFns } from "./book-top.vue?vue&type=template&id=28a336d0&scoped=true&"
import script from "./book-top.vue?vue&type=script&lang=js&"
export * from "./book-top.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a336d0",
  null
  
)

export default component.exports